import {reactFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {UpdateIssuesBulk} from '@github-ui/server-persisted-queries'
import type {UpdateIssuesBulkMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulk'

type UpdateIssueIssueTypeBulkRequestBase = {
  ids: string[]
}

type UpdateIssueIssueTypeBulkRequestWithIssueTypeId = UpdateIssueIssueTypeBulkRequestBase & {
  issueTypeId: string
}

type UpdateIssueIssueTypeBulkRequestWithClearIssueType = UpdateIssueIssueTypeBulkRequestBase & {
  clearIssueType: true
}

export type UpdateIssueIssueTypeBulkRequest =
  | UpdateIssueIssueTypeBulkRequestWithIssueTypeId
  | UpdateIssueIssueTypeBulkRequestWithClearIssueType

export type UpdateIssueIssueTypeBulkResponse = GraphQLResponse<UpdateIssuesBulkMutation>

export async function apiUpdateIssueIssueTypeBulk(
  request: UpdateIssueIssueTypeBulkRequest,
): Promise<UpdateIssueIssueTypeBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {ids: request.ids, queryId: UpdateIssuesBulk}

  if ('issueTypeId' in request) {
    body.issueTypeId = request.issueTypeId
  } else {
    body.clearIssueType = request.clearIssueType
  }
  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await reactFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueIssueTypeBulkResponse>
}
